import { motion } from "framer-motion";
import ShopSection from "@/components/ShopSection";
import Footer from "@/components/Footer";

const EASE = [0.16, 1, 0.3, 1];

export default function Shop() {
  return (
    <main data-testid="shop-page" className="bg-cream">
      <div className="border-b border-forest/10 pb-16 pt-36 lg:pt-44">
        <div className="mx-auto max-w-7xl px-6 lg:px-10">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: EASE }}
            className="mb-4 text-xs font-bold uppercase tracking-[0.3em] text-sage"
          >
            Utsav Flowers · Dibrugarh
          </motion.p>
          <h1 className="font-serif text-5xl font-medium tracking-tight text-forest md:text-7xl">
            <span className="block overflow-hidden">
              <motion.span
                className="block"
                initial={{ y: "115%" }}
                animate={{ y: 0 }}
                transition={{ duration: 1, delay: 0.15, ease: EASE }}
              >
                The <span className="italic text-marigold">Collection</span>
              </motion.span>
            </span>
          </h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4, ease: EASE }}
            className="mt-6 max-w-lg text-base leading-relaxed text-sage"
          >
            Fresh cut flowers, hand-tied bouquets, everlasting artificials and
            thoughtful gifts — delivered across Dibrugarh.
          </motion.p>
        </div>
      </div>
      <ShopSection compact />
      <Footer />
    </main>
  );
}
